"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var component_1 = require("./component");
Object.defineProperty(exports, "Component", { enumerable: true, get: function () { return component_1.Component; } });
//# sourceMappingURL=index.js.map